$(function () {
    var updating = false;
    $(window).on("resize", function (e) {
        if (!updating) {
            window.requestAnimationFrame(function () {
                if ($(".ar-navigation").hasClass("ar-navigation_open")) {
                    $(".ar-navigation .ar-navigation__menu-container").css("height", function () {
                        return window.innerHeight - this.getBoundingClientRect().top;
                    });
                }
                updating = false;
            });
            updating = true;
        }
    });


    $(".ar-navigation")
        .on("click", ".ar-navigation__opener", function (e) {
            e.preventDefault();

            var navigation = $(this).closest(".ar-navigation");
            var menuContainer = $(".ar-navigation__menu-container", navigation);

            if (!navigation.hasClass("ar-navigation_open")) {
                navigation.addClass("ar-navigation_open");
                $("body").addClass("no-scroll");
                menuContainer.css("height", window.innerHeight - menuContainer[0].getBoundingClientRect().top);
            }
            else {
                navigation.removeClass("ar-navigation_open");
                $("body").removeClass("no-scroll");
                menuContainer.css("height", 0);
            }
        })
        .on("click", ".ar-navigation__menu-opener", function (e) {
            e.preventDefault();

            $(this)
                .closest(".ar-navigation__menu-item")
                .toggleClass("ar-navigation__menu-item_open");
        })
        .on("click", ".ar-navigation__menu", function (e) {
            e.stopPropagation();
        })
        .on("click", ".ar-navigation__menu-container", function (e) {
            $(this)
                .closest(".ar-navigation")
                .removeClass("ar-navigation_open");

            $("body").removeClass("no-scroll");
        });
});